export const formatNumberDecimal = (num) => {
  // Redondeamos el número a un máximo de 5 decimales
  num = Math.round(num * 100) / 100
  // num = Number(num?.toFixed(2));

  // Convertimos el número a una cadena y separamos la parte entera y decimal
  let parts = num?.toString()?.split('.');
  parts[0] = isNaN(parts[0]) ? '0' : parts[0];

  // Si el número no tiene parte decimal, añadimos '.00'
  if (parts.length === 1) {
    parts.push('00');
  }

  // Si la parte decimal tiene menos de 2 dígitos, añadimos ceros a la derecha
  if (parts[1].length < 2) {
    parts[1] = parts[1] + '0'.repeat(2 - parts[1].length);
  }

  // Separamos la parte entera en grupos de 3 dígitos
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Unimos la parte entera y decimal con un punto como separador decimal
  return parts.join('.');
}

export const formatNumber = (num) => {
  // Redondeamos el número a un máximo de 5 decimales
  num = Number(num?.toFixed(4));

  // Convertimos el número a una cadena y separamos la parte entera y decimal
  let parts = num.toString().split('.');

  // Si el número no tiene parte decimal, añadimos '.00'
  if (parts.length === 1) {
    parts.push('0000');
  }

  // Si la parte decimal tiene menos de 2 dígitos, añadimos ceros a la derecha
  if (parts[1].length < 4) {
    parts[1] = parts[1] + '0'.repeat(4 - parts[1].length);
  }

  // Separamos la parte entera en grupos de 3 dígitos
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Unimos la parte entera y decimal con un punto como separador decimal
  return parts.join('.');
}

export const formatSmallNumber = (value) => {
  if (value < 0) {
    let newN = value * (-1)
    if (newN >= 1000000) {
      return formatNumberDecimal(value / 1000000) + ' M'
    } else {
      if (newN >= 1000) {
        return formatNumberDecimal(value / 1000) + ' k'
      } else {

        let num = value?.toString()?.split('.')
       
        return num[0]
      }

    }
  }
  if(value){
    if (value >= 1000000) {
      return formatNumberDecimal(value / 1000000) + ' M'
    } else {
      if (value >= 1000 ) {
        return formatNumberDecimal(value / 1000) + ' k'
      } else {
       
        let num = value?.toString()?.split('.')
        
        return num[0]
      }
  
    }

  }else{
    return 0
  }

}

export const PorcentajeFormat = (value) => {
  if (value) {
    return formatNumberDecimal(value) + ' %'
  } else {
    return 0.0 + ' %'
  }
}

export const formatNumber3Dec = (num) => {
  num = parseFloat(num);
  num = Number(num?.toFixed(3));

  let parts = num.toString().split('.');

  if (parts.length === 1) {
    parts.push('000');
  }

  if (parts[1].length === 2) {
    parts[1] = parts[1] + '0';
  }

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join('.');
}

export const formatDateWithTime = () => {
  //fecha y hora actual
  const today = new Date();

  // Formatea la fecha (día/mes/año)
  const day = today.getDate().toString().padStart(2, '0');
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Los meses son 0-indexados
  const year = today.getFullYear();

  // Formatea la hora en formato 12 horas con AM/PM
  let formattedTime = today.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  formattedTime = formattedTime.toUpperCase();

  return `${day}/${month}/${year} ${formattedTime}`;
}

//formatear a 2 decimales
export const formatNumberTwoDecimals = (num) => {
  if (isNaN(num) || num === null || num === undefined) return "0.00";

  // Redondeamos a 2 decimales
  num = Number(num.toFixed(2));

  // Convertimos el número a cadena y separamos parte entera y decimal
  let parts = num.toString().split(".");

  // Agregar separadores de miles a la parte entera
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Asegurarnos de que siempre tenga 2 decimales
  if (!parts[1]) {
    parts[1] = "00";
  } else if (parts[1].length < 2) {
    parts[1] = parts[1] + "0";
  }

  return parts.join(".");
};





